<template>
  <div class="">
    <company-sectors-create> </company-sectors-create>
  </div>
</template>

<script>
import CompanySectorsCreate from "@/components/profile/sectors/company/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    CompanySectorsCreate,
  },
  created() {
    this.notifyQueue({
      text: "Comparti di compagnia",
      path: "module.PROF.COMP",
      tab: "CompanySectors",
      level: 3,
    });
    this.notifyQueue({
      text: "Crea Comparto di compagnia",
      path: "sectors.create1",
      level: 4,
    });
  },
};
</script>
